Kadenze.Timers = [];
const self = {
  init: function() {
    console.log('Initializing WebApp Module');
    var $container = $('body');
    self.setTimeZone();
    self.runInitializers($container);
    self.checkTimeoutStatus();
    self.checkRailsNotices();
    self.checkResetMixpanel();
  },

  runInitializers: function($container) {
    self.initFormElements($container);
    self.initDatepicker($container);
    self.checkPreview($container);
    self.initWysiwygLinks($container);
    self.initHelpTooltips($container);
    self.initSliders($container);
    self.initEditors($container);
    self.highlightCode($container);
    self.initDropzoneConfig();
    self.initConfirmDelete();
    self.initProgressBar();
    self.initFileBoxes();
    self.initKadenzeTooltips($container);
    Kadenze.UIUtil.initDotDotDotTruncation();
    Kadenze.UIUtil.initExpandableText();
    Kadenze.UIUtil.initTabAreas();
    Kadenze.UIUtil.initModalFocusEvents();
    Kadenze.UIUtil.initClipboard();
    Kadenze.UIUtil.initSmoothScroll();
    Kadenze.UIUtil.initSelectPickerEvents();
    Kadenze.UIUtil.initTabKeyFocus();
    Kadenze.KdTabs.init();
    (new Kadenze.KdForms()).init();
    Kadenze.IframeUtils.decorateAll();
    self.initMobileAppLogin();
  },

  initContent: function(container) {
    console.log('Initializing content for container ' + container.id);
    self.runInitializers($(container));
  },

  initializePjax: function() {
    if ($.support.pjax) {
      $.pjax.defaults.maxCacheLength = 0; //To avoid issues with JS frameworks that do their own DOM rendering
    }

    $(document).pjax('a[href]:not([data-remote]):not([data-behavior]):not([data-skip-pjax]):not([target="_blank"])', '[data-pjax-container]', {timeout: 5000});

    // update the mobile nav header with the new page title
    $(document).on('pjax:end', function(){
      $('#js_page-header-container--nav').html($('#js_page-header-container').html());
    });
  },

  clearTimers: function(container) {
    while (Kadenze.Timers.length > 0) {
      clearInterval(Kadenze.Timers.shift());
    }
  },

  setTimeZone: function() {
    $.cookie('browser.timezone', jstz.determine().name(), { expires: 365, path: '/' });
    moment.tz.setDefault(self.getTimeZone());
  },

  getTimeZone: function() {
    return $.cookie('user.timezone') || $.cookie('browser.timezone');
  },

  checkTimeoutStatus: function() {
    if (!Kadenze.Routes.session_time_left_path) {
      return;
    }
    var timer = setInterval(function() {
      Kadenze.onModuleLoaded('AjaxRequest', function(){
        var request = new Kadenze.AjaxRequest({
          type: 'GET',
          url: Kadenze.Routes.session_time_left_path(),
          headers: {
            'X-SILENCE-LOGGER': true
          }
        });

        request.done(function(data) {
          if (data.time_left && parseInt(data.time_left, 10) < (5 * 60)) {
            Kadenze.onModuleLoaded('UIUtil', function() {
              Kadenze.UIUtil.showTimeoutWarning((data.time_left / 60).floor);
            });
            clearInterval(timer);
          }
        });
      });
    }, 60000 * 5);

    Kadenze.Timers.push(timer);
  },

  gaPageTrack: function() {
    if (typeof ga === 'function') {
      ga('set', 'location', location.href);
      // ga('set', 'page', location.pathname)
      ga('send', 'pageview', {'title': document.title});
    }
  },

  onHjLoaded: function(callback) {
    if(typeof hj === 'function') {
      if(typeof callback === 'function') {
        return callback();
      }
    } else {
      setTimeout(Kadenze.WebApp.onHjLoaded.bind(this, callback), 100);
    }
  },

  onFbLoaded: function(callback) {
    if(typeof fbq === 'function') {
      if(typeof callback === 'function') {
        return callback();
      }
    } else {
      setTimeout(Kadenze.WebApp.onFbLoaded.bind(this, callback), 100);
    }
  },

  fbEventTrack: function(tag, data) {
    data = data || {};
    Kadenze.WebApp.onFbLoaded(() => {
      fbq('track', tag, data);
    });
  },

  // Check for rails notices and fade them out after 5 seconds
  checkRailsNotices: function() {
    var $railsNotice = $('.notice-rails');
    if($railsNotice.length) {
      setTimeout(function() {
        Kadenze.UIUtil.removeNotices();
      }, 5000);
    }
  },

  checkResetMixpanel: function() {
    Kadenze.onModuleLoaded('Util', function() {
      if (Kadenze.Util.getParameterByName('signed_out')) {
        Kadenze.onModuleLoaded('Analytics', function() {
          Kadenze.Analytics.resetTrackingData();
        });
      }
    });
  },

  initFormElements: function($container) {
    var _setCheckbox = function($ele) {
      var targetID = $ele.attr('id');
      var $label = $('label[for=\'' + targetID + '\']');
      if( $ele.is(':checked') ) {
        // $label.css("background-position", "0px -32px");
        $label.addClass('selected');
      } else {
        // $label.css("background-position", "0px 0");
        $label.removeClass('selected');
      }
    };

    $('body').off('click.checkbox').on('click.checkbox', 'input[type=checkbox]', function(e) {
      _setCheckbox($(this));
    });

    $( 'input[type=checkbox]', $container ).each(function() {
      _setCheckbox($(this));
    });

    var _setRadioButtons = function(ele) {
      var $ele = $(ele);

      console.log($ele);
      $( 'input[name=\''+ $ele.attr('name') +'\' ]', $container).each( function() {
        // $("label[for='" + $(this).attr("id") + "']").css("background-position", "0px 0");
        $('label[for=\'' + $(this).attr('id') + '\']').removeClass('selected');
      });
      var targetID = $ele.attr('id');
      var $label = $('label[for=\'' + targetID + '\']');
      if( $ele.is(':checked') ) {
        // $label.css("background-position", "0px -32px");
        $label.addClass('selected');
      } else {
        // $label.css("background-position", "0px 0");
        $label.removeClass('selected');
      }
    };

    var _radioClickHandler = function() {
      _setRadioButtons($(this));
    };

    $('body').off('click.radio').on('click.radio', 'input[type=radio]', function() {
      _setRadioButtons(this);
    });

    $('body').off('focus.radio').on('focus.radio', 'input[type=radio]', function() {
      $('label[for=\'' + $(this).attr('id') + '\']').addClass('focused');
    });
    $('body').off('blur.radio').on('blur.radio', 'input[type=radio]', function() {
      $('label[for=\'' + $(this).attr('id') + '\']').removeClass('focused');
    });

    $('input[type=radio]', $container).each(function() {
      if ($(this).is(':checked')) {
        _setRadioButtons($(this));
      }
    });

    $('.selectpicker', $container).selectpicker();
    $('.selectpicker-typeahead', $container).selectpicker({
      dropupAuto: false
    });

    // trim spaces from the beginning/end of non-password text fields before submitting
    $('body').on('keydown', 'input[type="text"]', function(e){
      if(e.which == 13) {
        trimSpaces(this);
      }
    });
    $('body').on('blur', 'input[type="text"]', function(e){
      trimSpaces(this);
    });
    var trimSpaces = function (inputObj){
      var rawVal = $(inputObj).val();
      var trimmedVal = rawVal.trim();
      $(inputObj).val(trimmedVal);
    };
  },

  initDatepicker: function($container) {
    $('.datetimepicker', $container).each(function() {
      var options = $(this).data();
      var input = $('input', $(this));
      options.pickSeconds = false;

      $(this).datetimepicker(options);
      if (options.setDate && !$.trim(input.val())) {
        var picker = $(this).data('DateTimePicker');
        picker.setDate(new Date(options.setDate));
        //let the datepicker start at our date, but clear out the input
        $('input', $(this)).val('');
      }
    });
  },

  exitPreview: function () {
    var exitPath = decodeURIComponent(Kadenze.Util.getParameterByName('exit_path'));
    if (exitPath && exitPath != '' && exitPath != 'null') {
      window.location = window.location.origin + exitPath;
    } else {
      var courseId = $('#course_id').val();
      if (!courseId) {
        courseId = window.location.pathname.match('/courses/(.*)/?')[1].split('/')[0];
      }
      window.location = Kadenze.Routes.course_path(courseId);
    }
  },

  checkPreview: function($container) {
    if (Kadenze.Util.getParameterByName('preview') === 'true') {
      // Add preview parameter to all links
      $container.on('click', 'a[href^="/"]', function(evt) {
        if ($(this).data('no-preview')) {
          return true;
        } else {
          var url = Kadenze.Util.insertURLParam($(this).attr('href'), 'preview', 'true');
          var exitPath = Kadenze.Util.getParameterByName('exit_path');
          if (exitPath) {
            $(this).attr('href', Kadenze.Util.insertURLParam(url, 'exit_path', exitPath));
          }
        }
        return true;
      });

      $('.js-exit-student-view').click(function() {
        Kadenze.WebApp.exitPreview();
      });
    }
  },

  initWysiwygLinks: function($container) {

    var container = $container[0];
    var re = /^(https?:\/\/[^\/]+).*$/;
    var currentHref = window.location.href.replace(re, '$1');
    var reLocal = new RegExp('^' + currentHref.replace(/\./, '\\.'));

    var links;
    if ($container.hasClass('wysiwyg-content')) {
      links = $('a', container);
    }
    else {
      links = $('.wysiwyg-content a', container);
    }

    if (links.length === 0)
      return;

    links.each(function(_idx, _ele) {
      var $_ele = $(_ele);
      var href = $_ele.attr('href');
      $_ele.attr('data-skip-pjax', true);
      if (href == '' || reLocal.test(href) || !re.test(href)) {
        // This is an internal link, let it slide
        return;
      }
      else {
        $_ele.attr('target', '_blank');
      }
    });
  },

  //Setup help and tips areas
  initHelpTooltips: function(aParent) {
    var $helpTooltip, $helpArrow;

    var _createTooltip = function() {
      $helpTooltip = $('#help-tooltip', aParent);
      if ($helpTooltip.length === 0) {
        // create it
        $helpTooltip = $(JST['templates/tooltip_large']());
        $helpTooltip.css({visiblity:'hidden',opacity:0});
        aParent.append($helpTooltip);
      }
    };

    $('[data-toggle="help-tooltip"]', aParent).each( function() {
      $(this).hover( function() {
        // If tooltips have been dynamically disabled on this element after the event has been attached, just return
        if ($(this).data('toggle') !== 'help-tooltip') {
          return;
        }
        // First see if this element specifies a help tooltip ID (for html tooltips)
        if ($(this).data('tooltip-id')) {
          $helpTooltip = $('#' + $(this).data('tooltip-id'));
          if (!$helpTooltip) {
            console.warn('tooltip id "' + $(this).data('tooltip-id') + '" specified, but no tooltip found ');
            return;
          }
        }
        else {
          // If not then use or create the standard one
          if (!$helpTooltip || $helpTooltip.legnth === 0) {
            _createTooltip();
          }
          $helpTooltip.find('.help-tooltip__title').text( $(this).attr('title') );
          $helpTooltip.find('.help-tooltip__description').text( $(this).data().description );
        }

        // Positioning and display
        $helpArrow = $helpTooltip.find('.help-tooltip__arrow');
        $helpTooltip.parent().css('position', 'relative');
        var arrPos = $(this).position().left - 35 + ( $(this).width() / 2 );
        var tipPos = $(this).position().top + $(this).outerHeight(true) + 15 ;

        $helpArrow.css({left: arrPos });
        $helpTooltip.css({top: tipPos });
        TweenLite.to($helpTooltip, 0.5, {autoAlpha:1});
      }, function() {
        TweenLite.to($helpTooltip, 0.5, {autoAlpha:0});
      } );
    });
  },

  //set up jquery UI sliders
  //expects a min and max attribute
  initSliders: function($container) {
    $('.slider', $container).each(function(idx, ele) {
      var $ele = $(ele);
      var min = parseInt($ele.attr('min'), 10) || 0;
      var max = parseInt($ele.attr('max'), 10) || 100;
      var step = parseInt($ele.data('step'), 10) || 1;
      //assume there is a hidden field sibling
      var $updateEle = $($(ele.data('target')));
      if ($updateEle.length === 0) {
        $updateEle = $ele.siblings('input[type="hidden"]');
        if ($updateEle.length === 0) {
          console.warn('Attempting to initialize slider for ' + $ele + ' but no target found');
        }
      }
      $ele.slider({
        min: min,
        max: max,
        step: step,
        change: function(evt, ui) {
          $updateEle.val(ui.value);
          //bold the label... for fun!
          $('span', $(this).siblings('.slider-label')).each(function(idx, ele) {
            if (parseInt($ele.text(), 10) === ui.value)
              $ele.addClass('strong');
            else
              $ele.removeClass('strong');
          });
        }
      });
      //attach our labels
      var label = $ele.siblings('.slider-label');
      var labelWidth = $ele.width() / (max - min) - 1;
      for (var i = min; i <= max; i++) {
        label.append('<span style="width: ' + labelWidth + 'px">' + i + '</span>');
      }
    });
  },

  initEditors: function($container) {
    $('.redactor', $container).each(function(idx, ele) {
      Kadenze.Redactor.init(ele);
    });
  },

  highlightCode: function($container) {
    $('code', $container).each(function(idx, ele) {
      Prism.highlightElement(ele);
    });
  },

  initDropzoneConfig: function() {
    Dropzone.autoDiscover = false;
    Dropzone.prototype.addMockFile = function(file) {
      var self = this;
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit('addedfile', file);
      this.emit('success', file, {
        files: [file]
      });
      if (file.thumb) {
        this.emit('thumbnail', file, file.thumb);
      }
      this.emit('complete', file);
    };

    Dropzone.prototype.isValid = function() {
      var valid = true;
      if (this.getRejectedFiles().length > 0) {
        valid = false;
      }
      return valid;
    };
  },

  initConfirmDelete: function() {
    $('a[data-confirm]').on('click.confirm', function() {
      var $ele = $(this);
      Kadenze.UIUtil.confirmAction($ele.data('confirm'), function() {
        var url = $ele.attr('href');
        var $parent = $ele.parents('tr, .js-delete-parent');

        $parent.fadeOut(500);

        var request = new Kadenze.AjaxRequest({
          url: url,
          type: 'DELETE'
        });

        request.done(function(data) {
          console.log(data);

          $parent.remove();

          new Kadenze.Notice.success({ message: data.message });
          if (data.redirect) {
            Kadenze.Request.pjax({ url: data.redirect });
          }
        });

        request.fail(function(data) {
          console.log(data);

          $container = $('.main-container').length > 0 ? $('#notice_container') : $('.main-container');

          new Kadenze.Notice.error({ message: data.message });

          $parent.fadeIn(500);
        });

      }); //confirmAction
      return false;
    }); //click

    $('form[data-kconfirm]').on('click.confirm', function() {
      var $ele = $(this);
      Kadenze.UIUtil.confirmAction($ele.data('kconfirm'), function() {
        $ele.submit();
      }); //confirmAction
      return false;
    });
  },

  initProgressBar: function() {
    console.log('PJAX ProgressBar initialized');
    if(!$('.kl-main__content').length)
      return;

    var startClickProgress = function (e) {
      if (!e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey) {
        NProgress.start();
      }
    };
    // NProgress progress bar
    NProgress.configure({ showSpinner: false, parent: '.kl-main__content', trickleRate: 0.02, trickleSpeed: 400 });
    $('body').on('click', 'a[data-skip-pjax="true"]:not([data-skip-loader])', startClickProgress);
    $(document).ready(NProgress.done);
    $(document).on('pjax:start',  NProgress.start);
    $(document).on('pjax:end',   NProgress.done);
  },

  initFileBoxes: function() {
    var $boxes = $('.js-kadenze-file');
    if ($boxes.length === 0) {
      return;
    }

    $boxes.each(function(idx, box) {
      var $box = $(box);
      var opts = {};

      var boxData = $box.data('file-json');
      if ($box.data('file-template').trim()) {
        opts['template'] = $box.data('file-template');
      }
      var fileObj = new Kadenze.GenericFileViewModel(boxData, $box, opts);
      fileObj.render();
    });
  },

  // Globally init tooltips based on the '.js-tooltip' class
  initKadenzeTooltips: function($container = $('body'), selector = '.js-tooltip') {
    var $tips = $container ? $container.find(selector) : $(selector);

    // Clear all tooltips, necessary between pjax requests
    $('.kadenze-tooltip').remove();

    $tips.each(function() {
      var $this = $(this);
      // If we've already instantiated, don't do it again.
      if(!$this.data('tooltip')) {
        // See scripts/common/tooltip.js for full documentation on options
        new Kadenze.Tooltip({ target: this });
      }
    });
  },

  initMobileAppLogin: function() {
    if(Kadenze.UIUtil.isMobileOrTablet()){
      $(document).ready(function() {
        (new Kadenze.KdForms()).init();
      });
    }
  }
};
export default self;
